import type { TOffer } from 'shared/types/TRankingService';

import { selectAllFormFields } from 'entities/creditForm';
import { isBentoRankingModelSelector } from 'entities/offers';
import { selectPledgeAutoData } from 'entities/pledgeAutoForm';
import { selectPledgeEstateData } from 'entities/pledgeEstateForm';
import { collectPromoAnalyticsDataSelector, collectWLOtherDataSelector } from 'entities/whiteLabels';

import type { TAdditionalData } from 'features/OfferControls';

import { offerToApplyOfferDataAdapter } from './offerToApplyOfferDataAdapter';

type SendOfferThunkProps = {
  offer: TOffer;
  other?: TAdditionalData;
};

export const collectOfferDataThunk =
  ({ offer, other }: SendOfferThunkProps): ThunkResult<ReturnType<typeof offerToApplyOfferDataAdapter>> =>
  (_, getState) => {
    const state = getState();
    const formData = selectAllFormFields(state);
    const pledgeAutoData = selectPledgeAutoData(state);
    const pledgeEstateData = selectPledgeEstateData(state);
    const isBentoRankingModel = isBentoRankingModelSelector(state);
    const otherWlData = collectWLOtherDataSelector(state);
    const promoAnalyticsData = collectPromoAnalyticsDataSelector(state);

    return offerToApplyOfferDataAdapter(
      offer,
      formData,
      {
        pledgeAutoData,
        pledgeEstateData,
        ...(isBentoRankingModel ? { isBentoRankingModel } : {}),
        ...other,
        ...otherWlData,
      },
      promoAnalyticsData,
    );
  };
